export default __webpack_public_path__ + "static/media/targeting.52b9985d.jpg";